import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import ProductCard from "../ProductCard";

const DealsShowcase = ({ type, trendingDeals, isAuthenticated = false }) => {
  return (
    <section id="deals" className="py-20 bg-gray-50">
      <div className="px-4 mx-auto max-w-8xl sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="flex flex-col gap-4 mb-12 lg:flex-row lg:justify-between lg:items-center lg:mb-16"
        >
          <h2 className="text-2xl font-bold text-gray-900 md:text-3xl lg:text-4xl xl:text-5xl">
            {type === "trending" ? "Trending" : "Fashion & Accessories"}
            <span className="bg-gradient-to-r from-[#FF7F7F] to-pink-500 bg-clip-text text-transparent">
              {" "}
              Deals
            </span>
          </h2>

          <Link
            to={isAuthenticated ? "/trending-authenticated" : "/trending"}
            className="inline-block bg-gradient-to-r from-[#FF7F7F] to-pink-500 hover:from-[#ff6b6b] hover:to-pink-400 text-white px-6 py-3 lg:px-8 lg:py-4 rounded-full font-semibold text-sm lg:text-lg transition-all duration-300 transform hover:scale-105 w-fit"
          >
            Browse All Products
          </Link>
        </motion.div>

        <div className="grid grid-cols-2 gap-4 md:gap-8 md:grid-cols-3 lg:grid-cols-4">
          {trendingDeals.map((deal, index) => (
            <ProductCard
              key={deal.id}
              deal={deal}
              index={index}
              isAuthenticated={isAuthenticated}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default DealsShowcase;
